var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",class:{transparent: !_vm.isLoading}},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated",staticStyle:{"width":"100%"},attrs:{"role":"progressbar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }